@if (isLocked()) {
    <!-- Presentation mode: subscriber stays visible as context, but the tenant list must not be openable. -->
    @if (isIconSize()) {
        <!-- NARROW while presenting: domain + lock only, no caret, no name (name stays in the tooltip). -->
        <span
            class="subscriber-chip-locked inline-flex h-[30px] flex-none cursor-default items-center gap-[2px] rounded bg-white/12 px-[10px] select-none dark:border dark:border-(--p-surface-700) dark:bg-(--p-surface-800)"
            [attr.title]="iconChipLabel()"
            [attr.aria-label]="iconChipLabel()"
        >
            <span class="material-symbols-outlined text-[16px] leading-none text-white/85 dark:text-(--p-surface-400)" aria-hidden="true">domain</span>
            <span class="material-symbols-outlined text-[15px] leading-none text-white/65 dark:text-(--p-surface-400)" aria-hidden="true">lock</span>
        </span>
    } @else {
        <span
            class="subscriber-chip-locked inline-flex h-[30px] w-[320px] min-w-[110px] shrink cursor-default items-center gap-1.5 rounded bg-white/12 px-2.5 text-[0.95rem] font-medium text-white select-none dark:border dark:border-(--p-surface-700) dark:bg-(--p-surface-800) dark:text-(--p-surface-100)"
            [attr.title]="selectedSubscriber()?.subscriberName ?? null"
        >
            <span class="material-symbols-outlined text-[16px] leading-none text-white/75 dark:text-(--p-surface-400)" aria-hidden="true">domain</span>
            @if (selectedSubscriber(); as subscriber) {
                <span class="min-w-0 truncate">{{ subscriber.subscriberName }}</span>
            } @else {
                <span class="truncate font-normal text-white/65 dark:text-(--p-surface-400)">{{ effectivePlaceholder() }}</span>
            }
            <!-- ml-auto pins the lock to the right edge, where the caret sits in the unlocked chip. -->
            <span class="material-symbols-outlined ml-auto text-[15px] leading-none text-white/65 dark:text-(--p-surface-400)" aria-hidden="true">lock</span>
        </span>
    }
} @else {
    <p-select
        #chipSelect
        id="subscriberChipSelect"
        [(ngModel)]="subscriberKey"
        [options]="options()"
        optionLabel="subscriberName"
        optionValue="subscriberKey"
        dataKey="subscriberKey"
        [placeholder]="effectivePlaceholder()"
        [loading]="isLoading()"

        [disabled]="isLoading()"

        appendTo="body"

        [styleClass]="chipStyleClass()"

        [attr.title]="iconChipLabel()"
        [attr.aria-label]="iconChipLabel()"
    >
        <ng-template #selectedItem let-selected>
            <span class="min-w-0 truncate" [title]="selected?.subscriberName">{{ selected?.subscriberName }}</span>
        </ng-template>
        <ng-template #dropdownicon>
            <span class="material-symbols-outlined text-[20px] leading-none" aria-hidden="true">arrow_drop_down</span>
        </ng-template>
        <ng-template #header>
            <!-- Icon-only tier hides the name in the bar, so the overlay surfaces the active subscriber
                 as a non-selectable header row — context is never lost. -->
            @if (isIconSize() && selectedSubscriber(); as subscriber) {
                <div class="subscriber-chip-current-row flex w-full items-center gap-2 border-b border-(--p-content-border-color) px-3 py-2 text-sm text-(--p-text-muted-color)">
                    <span class="material-symbols-outlined text-[1rem]" aria-hidden="true">domain</span>
                    <span class="min-w-0 truncate">{{ subscriber.subscriberName }}</span>
                </div>
            }
        </ng-template>
        <ng-template #footer>
            <!-- The clear action lives here (not as an in-field ✕) so the global subscriber can't be cleared by one stray click. -->
            @if (subscriberKey() !== null) {
                <button
                    type="button"
                    class="subscriber-chip-clear-row flex w-full cursor-pointer items-center gap-2 border-t border-(--p-content-border-color) bg-transparent px-3 py-2 text-sm text-(--p-text-muted-color) transition-colors hover:bg-(--p-content-hover-background)"
                    (click)="onClearSubscriberClicked(chipSelect)"
                >
                    <span class="material-symbols-outlined text-[1rem]" aria-hidden="true">close</span>
                    Clear subscriber
                </button>
            }
        </ng-template>
    </p-select>
}
